import { Box, ChakraProvider, Drawer, DrawerContent, DrawerOverlay, Flex, IconButton, useDisclosure } from '@chakra-ui/react';
import { Outlet } from 'react-router-dom';
import { employeeTheme } from '../design';
import EmployeeSidebar from './EmployeeSidebar';
import { FiMenu } from 'react-icons/fi';

export default function EmployeeLayout() {
    return (
        <ChakraProvider theme={employeeTheme}>
            <Layout />
        </ChakraProvider>
    )
}

const Layout = () => {
    const { isOpen, onOpen, onClose } = useDisclosure();

    return (
        <Box minH={'100vh'} backgroundColor={'#EDF2F7'}>
            <EmployeeSidebar onClose={onClose} display={{ base: 'none', md: 'block' }} />

            <Drawer autoFocus={false} isOpen={isOpen} placement="left" onClose={onClose} returnFocusOnClose={false} onOverlayClick={onClose}>
                <DrawerOverlay />
                <DrawerContent>
                    <EmployeeSidebar onClose={onClose} />
                </DrawerContent>
            </Drawer>

            <Flex
                ml={{ base: 0, md: '250px' }}
                flexDir="column"
                minH="100vh"
                bgGradient="linear(to-br, orange.50, white)"
            >

                <IconButton
                    display={{ base: 'flex', md: 'none' }}
                    onClick={onOpen}
                    icon={<FiMenu />}
                    variant="outline"
                    aria-label="open menu"
                />

                <Box w="full" px={{ base: 2, md: 5 }} py={4}>
                    <Outlet />
                </Box>
            </Flex>
        </Box>
    )
}
